import Cookies from 'js-cookie';
import { AUTH_COOKIES_NAME } from 'src/constants/configuration';

export const setAuthCookie = (cookieValue) => {
  Cookies.set(AUTH_COOKIES_NAME, cookieValue);
}

export const getAuthCookie = () => {
  return Cookies.get(AUTH_COOKIES_NAME);
}

export const deleteAuthCookie = () => {
  setAuthCookie('');
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js